import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

// import { makeServer } from './services/mirage';

// const apiUrl = process.env.REACT_APP_API_URL;
// // porta padrão do makeServer
// if (apiUrl && apiUrl.includes('api')) {
//   makeServer();
// }

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
